module.exports = __webpack_public_path__ + "img/588x310-02.489a8081.png";